export default __webpack_public_path__ + "static/media/fire2.cfeb2a2d.png";